var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-medium well m-auto mt-8 relative" },
    [
      _c(
        "ul",
        { staticClass: "m-0" },
        _vm._l(_vm.plugins, function(plugin, indexPlugin) {
          return _c(
            "li",
            {
              key: indexPlugin,
              staticClass: "dinlineb span_2 gutters valign-top acenter"
            },
            [
              _c(
                "a",
                {
                  staticClass:
                    "block px-2 py-4 b-1-black-hover cpointer br w-160 m-auto pref-link",
                  attrs: {
                    href: plugin.url,
                    onClick: plugin.call,
                    target: plugin.target
                  }
                },
                [
                  plugin.compassicon
                    ? _c("CompassIcon", {
                        attrs: { icon: plugin.compassicon, size: "large" }
                      })
                    : plugin.iconSvg
                    ? _c(
                        "icon-svg",
                        {
                          staticStyle: { color: "grey" },
                          attrs: {
                            "view-box": "0 0 26 26",
                            width: 26,
                            height: 26,
                            iconName: plugin.iconSvg
                          }
                        },
                        [_c(plugin.iconSvg, { tag: "component" })],
                        1
                      )
                    : _c("i", { staticClass: "grey fs-6", class: plugin.icon }),
                  _vm._v(" "),
                  _c("p", { staticClass: "gray-100 fs-3 semibold m-0 mt-2" }, [
                    _vm._v(_vm._s(plugin.label))
                  ])
                ],
                1
              )
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.permissions.can_add_module
        ? _c("CompassButton", {
            staticClass: "absolute bottom-right-5",
            attrs: {
              label: _vm.$t.__("settings.SettingsInternalPlugin.add_modules"),
              type: "secondary"
            },
            on: { click: _vm.redirectionAddModules }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }